import { FunctionComponent } from "react";
import styles from "./SubmitButton.module.css";

interface SubmitButtonProps{
  handleSubmit: () => void
}
const SubmitButton: FunctionComponent<SubmitButtonProps> = ({handleSubmit}) => {
  return (
    <div className={styles.buttons} onClick={handleSubmit}>
      <b className={styles.apply}>Apply</b>
    </div>
  );
};

export default SubmitButton;
